export default __webpack_public_path__ + "static/char-v-05-94881ddd30a4a28f51ba530c3efecbe8.png";